import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import GeneralServices from '../../../app/service/generalServices'
import LancarFechamentoBancarioService from '../../../app/service/conciliacaoBancaria/lancarFechamentoBancarioService'
import ConstantsUtil from '../../../context/constantsUtil'
import { Button } from 'primereact/button'
import { classNames } from 'primereact/utils'
import TableFilters from '../../tableFilters'
import ExpansionTableButton from '../../relatorios/DRE/expansionTableButton'
import { Tooltip } from '@mui/material'

class FolhaDePagamentoTable extends React.Component {

    state = {
        
        loading: false,

        forceUpdateDialog: false,

        selectedValoresMeses: {},

        expanded: false,

        didUpdate: false,

        tableFilteredList: [],
        primaryFilter: '',

    }

    constructor(){
        super();
        this.lancarFechamentoBancarioService = new LancarFechamentoBancarioService();
        this.tableFilters = new TableFilters();

    }

    componentDidUpdate(){
        if(!this.state.didUpdate){
            let selectedValoresMeses = {}
            if(this.props.relatorio?.descricaoMesesList){
                this.props.relatorio.descricaoMesesList.forEach(descricaoMes => {
                    selectedValoresMeses[descricaoMes] = null
                })
            }
            this.setState({selectedValoresMeses})
            this.setState({didUpdate: true})
            this.setState({tableFilteredList: this.props.relatorio.list})

        }
    }

    rowClass(rowData) {
        const obj = {
            [ConstantsUtil.totaisTableLabel] : rowData.item.descricao === ConstantsUtil.tipoTotaisFichaBancariaLabel || rowData.item.descricao ===  ConstantsUtil.liquidoComAcentoabel
        }

        return obj
    }

    formattedListToExportByExcel(){
        var formattedList = []

        this.props.relatorio.list.forEach(item =>{

            // console.log("item:", item)
            
            var obj = {
                [this.props.tipo === ConstantsUtil.proventoFolha ? ConstantsUtil.proventoLabel : ConstantsUtil.descontoLabel]: item.descricao,
            }

            this.props.relatorio.descricaoMesesList.forEach(descricaoMes => {
                // console.log("descricaoMes", descricaoMes)
                const mesItem = item.relatorioMesMap[descricaoMes]
                // console.log("mesItem: ", mesItem)
                let valor = ''
                if(mesItem){
                    valor = mesItem.total
                }
                else{
                    valor = 0
                }
                obj[descricaoMes] = valor
            })

            obj.Total = item.total
            formattedList.push(obj)
        })

        return formattedList
    }

    generateWorkSheet(){
        const worksheet = GeneralServices.jsonToSheet(this.formattedListToExportByExcel());
        return worksheet
    }

    exportExcel = () => {
        // const periodo = this.props.dreConsolidado.initialDate + " - " + this.props.dreConsolidado.initialDate
        const worksheet = this.generateWorkSheet()
        const sheetName = "Folha de Pagamento"
        const workbook = { Sheets: { [sheetName]: worksheet }, SheetNames: [[sheetName]] };
        this.props.saveAsExcelFile(workbook, `Folha de Pagamento`);
    }

    filterList = (filterColumnName) => {

        // console.log("this.props.relatorio.list: ", this.props.relatorio.list)
        if(!this.state.expanded && this.props.relatorio && this.props.relatorio.list){
            let listToBeReturned = this.props.relatorio.list.filter(item => item.item.descricao ===  ConstantsUtil.tipoTotaisFichaBancariaLabel || item.item.descricao ===  ConstantsUtil.liquidoComAcentoabel)
            this.props.resetTotalItem(listToBeReturned)
            // console.log("filterList: ", listToBeReturned)
            return listToBeReturned
        }
        if(filterColumnName && this.state.primaryFilter && (this.state.primaryFilter !== filterColumnName)){
            /*
            Se a coluna que está sendo filtrada é o filtro primário, então envia toda a lista.
            Caso contrário, envia apenas a lista filtrada.
            */
            return this.state.tableFilteredList
        }

        // console.log("return: ", this.props.relatorio?.list)
        return this.props.relatorio?.list
    }

    updateValorMesFilter = async (descricaoMes, value) => {
        // console.log("updateValorMesFilter: ", descricaoMes, value)
        let selectedValoresMeses = this.state.selectedValoresMeses
        selectedValoresMeses[descricaoMes] = value

        this.checkPrimaryFilter(descricaoMes)

        await this.setState({selectedValoresMeses})
        // console.log("selectedValoresMeses: ", this.state.selectedValoresMeses)
    }

    checkPrimaryFilter = async (filterColumn) => {
        if(this.state.tableFilteredList.length === this.filterList().length){
            await this.setState({primaryFilter: filterColumn})
            // console.log("primaryFilter: ", this.state.primaryFilter)
        }
    }

    renderMesTableFilter = (descricaoMes) => {
        // console.log("this.tableFilters: ", descricaoMes)
        return (
            <div className='right-align'>
                {this.tableFilters.renderTableFilter(
                    this.props.dt,
                    this.state.selectedValoresMeses[descricaoMes],
                    this.filterList(descricaoMes),
                    descricaoMes,
                    this.updateValorMesFilter,
                    descricaoMes,
                    '100%',
                    "Total"
                )}
            </div>
        )
    }

    onFilterTable = async (currentList) => {
        // console.log("currentList: ", currentList)
        this.props.onFilterTable(currentList, this.props.dt)
        // console.log("tableFilteredList: ", currentList)
        this.setState({tableFilteredList: currentList})
    }

    getTooltipFromMesValor = (mesValor) => {
        if (!mesValor.detalhamentoValorList || mesValor.detalhamentoValorList.length === 0) {
            return '';
        }

        const total = mesValor.detalhamentoValorList.reduce(
            (acc, d) => acc + (d.valor || 0),
            0
        );

        return (
            <div>
                {mesValor.detalhamentoValorList.map((d, index) => (
                    <div key={index}>
                        <b>{d.descricaoMes}:</b> {GeneralServices.showFormattedIfNotNull(d.valor)}
                    </div>
                ))}

                <hr style={{ margin: '6px 0', borderColor: '#475569' }} />

                <div>
                    <b>Total:</b> {GeneralServices.showFormattedIfNotNull(total, true)}
                </div>
            </div>
        );
    }

    getHeaderLabel = () => {
        switch(this.props.tipo){

            case ConstantsUtil.proventoFolha:
                return ConstantsUtil.proventoLabel
            
            case ConstantsUtil.descontoFolha:
                return ConstantsUtil.descontoLabel
            
            case ConstantsUtil.liquidoFolha:
                return ConstantsUtil.liquidoLabel

        }
    }

    render (){

        const renderMesesColumn = () => {
            var mesesColumnList = []

            if(this.props.relatorio && this.props.relatorio.list && this.props.relatorio.list.length !== 0){
                this.props.relatorio.descricaoMesesList.forEach(descricaoMes => {
                    // console.log("descricaoMes: ", descricaoMes)
                    mesesColumnList.push(renderColumnItem(descricaoMes))
                });
            }

            return mesesColumnList
        }

        const renderColumnItem = (descricaoMes) => {
            return (
                <Column
                    field={descricaoMes}
                    header={<div className='right-align' style={{height: ConstantsUtil.heightHeaderDREConsolidado}}>{descricaoMes}</div>}
                    style ={ {width: GeneralServices.porcentagemColunaTabelaMesesConsolidados(this.props.qtdMeses, ConstantsUtil.tipoColunaMes)} }
                    // filter={this.state.expanded} filterElement={this.renderMesTableFilter(descricaoMes)}
                    body={item => {
                        const mesValor = item.relatorioMesMap[descricaoMes]
                        // console.log("mesValor: ", mesValor)
                        return (
                            <div className='right-align'>
                                {renderViewLancamentosLink(item, descricaoMes, mesValor)}
                            </div>
                        )
                    }
                    }
                />
            )
        }

        const renderViewLancamentosLink = (item, descricaoMes, mesValor) => {
            // console.log("item: ", item)
            // console.log("mesValor: ", mesValor)
            // console.log("\n\n")
            const cond1 = item.relatorioMesMap[descricaoMes] && item.relatorioMesMap[descricaoMes] && item.relatorioMesMap[descricaoMes] !== 0
            const cond2 = item.descricao !== ConstantsUtil.tipoTotaisFichaBancariaLabel
            if( cond1 && cond2 ){
                const classes = classNames({
                    // 'superavitValue': valorNaoFormatado >= 0,
                    'deficitValue': mesValor.total < 0,
                    'linkValue': true,
                    "small-font": true,
                    
                });
                return(
                    <Tooltip
                        title={this.getTooltipFromMesValor(mesValor)}
                        placement="right-start"
                        arrow
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    bgcolor: '#1e293b',
                                    color: '#fff',
                                    fontSize: '0.85rem',
                                    borderRadius: '8px',
                                    padding: '10px 14px',
                                    boxShadow: 3,
                                }
                            },
                            arrow: {
                                sx: {
                                    color: '#1e293b'
                                }
                            }
                        }}                        
                    >
                    <a
                        className={classes}
                    >
                        { mesValor && mesValor.total ? GeneralServices.showFormattedIfNotNull(mesValor.total, true) : ConstantsUtil.valueFormattedZero}
                    </a>
                    </Tooltip>
                )
            }
            else{
                return(
                    mesValor && mesValor.total ? GeneralServices.showFormattedIfNotNull(mesValor.showTotal, true) : ConstantsUtil.valueFormattedZero
                )
            }
        }


        const codigoFilterElement = this.tableFilters.renderTableFilter(
            this.props.dt,
            this.state.selectedCodigo,
            this.filterList("selectedCodigo"),
            "selectedCodigo",
            (name, value) => {
                this.setState({[name]: value})
                this.checkPrimaryFilter(name)
            },
            'codigo',
            '100%',
            "Código"
        )

        const nomeFilterElement = this.tableFilters.renderTableFilter(
            this.props.dt,
            this.state.selectedNome,
            this.filterList("selectedNome"),
            "selectedNome",
            (name, value) => {
                this.setState({[name]: value})
                this.checkPrimaryFilter(name)
            },
            'nome',
            '100%',
            "Descrição"
        )

        const renderTable = () => {
            return (
                <DataTable
                    ref={this.props.dt}
                    className="p-datatable-sm small-font"
                    value={this.filterList()}
                    onValueChange={this.onFilterTable}
                    rowClassName={this.rowClass}
                    rowHover
                    showGridlines
                    // scrollable
                    // scrollHeight="500px"
                    style={{ maxWidth: '100vw' }}
                    frozenWidth={ConstantsUtil.widthColumNomeDreConsolidado}
                    loading={this.props.loading || this.state.loading}
                    dataKey="id"
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                >
    
                <Column
                    // field="item.descricao"
                    field="codigo"
                    header={<div style={{height: ConstantsUtil.heightHeaderDREConsolidado}}>{"Código"}</div>}
                    filter={this.state.expanded} filterElement={codigoFilterElement}
                    frozen
                    // style ={ {width: ConstantsUtil.widthColumNomeDreConsolidado} }
                    style ={ {width: GeneralServices.porcentagemColunaTabelaMesesConsolidados(this.props.qtdMeses, ConstantsUtil.tipoColunaNome)} }
                    body = { (rowData, rowIndex) => {
                        // console.log("rowData:", rowData)
                        // console.log("rowIndex:", rowIndex.rowIndex)
                        const uniqueId = `name_${rowIndex.rowIndex}`;
                        return(
                            <div
                                style ={ {
                                    whiteSpace: 'nowrap', /* Impede que o texto quebre em várias linhas */
                                    overflow: 'hidden', /* Esconde qualquer conteúdo que exceda o width da coluna */
                                    textOverflow: 'ellipsis', /* Adiciona reticências (...) ao final do texto cortado */
                                } }
                                title={rowData.showCodigo}
                            >
    
                                <span id={uniqueId}>{rowData.showCodigo}</span>
    
                            </div>
                        );
                    }}
                />

                <Column
                    // field="item.descricao"
                    field="nome"
                    header={<div style={{height: ConstantsUtil.heightHeaderDREConsolidado}}>{"Descrição"}</div>}
                    filter={this.state.expanded} filterElement={nomeFilterElement}
                    frozen
                    // style ={ {width: ConstantsUtil.widthColumNomeDreConsolidado} }
                    style ={ {width: GeneralServices.porcentagemColunaTabelaMesesConsolidados(this.props.qtdMeses, ConstantsUtil.tipoColunaNome)} }
                    body = { (rowData, rowIndex) => {
                        // console.log("rowData:", rowData)
                        // console.log("rowIndex:", rowIndex.rowIndex)
                        const uniqueId = `name_${rowIndex.rowIndex}`;
                        return(
                            <div
                                style ={ {
                                    whiteSpace: 'nowrap', /* Impede que o texto quebre em várias linhas */
                                    overflow: 'hidden', /* Esconde qualquer conteúdo que exceda o width da coluna */
                                    textOverflow: 'ellipsis', /* Adiciona reticências (...) ao final do texto cortado */
                                } }
                                title={rowData.showNome}
                            >
    
                                <span id={uniqueId}>{rowData.showNome}</span>
    
                            </div>
                        );
                    }}
                />
    
                {renderMesesColumn()}
    
                <Column field="total"
                    header={
                        <div className='right-align' style={{height: ConstantsUtil.heightHeaderDREConsolidado}}>
                            Total
                        </div>
                    }
                    // style ={ {width: ConstantsUtil.widthColumDreConsolidado} }
                    style ={ {width: GeneralServices.porcentagemColunaTabelaMesesConsolidados(this.props.qtdMeses, ConstantsUtil.tipoColunaMes)} }
                    body = {rowData =>
                        {   
                            return (
                            <div className='right-align' 
                                // style ={ {height: '100vh'} }
                            >
                                {
                                    GeneralServices.showFormattedIfNotNull(rowData.showTotal, true)
                                }
                            </div>
                            )
                        }
                    }
                />
    
                {/* <Column
                    field="porcentagem"
                    // header="%"
                    header={<div className='right-align' style={{height: ConstantsUtil.heightHeaderDREConsolidado}}>%</div>}
                    // style ={ {width: ConstantsUtil.widthColumDrePorcentagemConsolidado} }
                    style ={ {width: GeneralServices.porcentagemColunaTabelaMesesConsolidados(this.props.qtdMeses, ConstantsUtil.tipoColunaPorcentagem)} }
                    body = {rowData => {
                        return(
                            <div className='right-align'>
                                {rowData.showPorcentagem}%
                            </div>
                        )
                    }}
                /> */}
    
                </DataTable>
            )
        }

        const renderExportarButton = () => {
            if(this.state.expanded){
                return (
                    <Button label="Exportar"
                        icon={<i className="pi pi-file-excel" style={{fontSize: '1em', marginRight: '0.5em'}}></i>}
                        className="p-button-success small-font"
                        onClick={this.exportExcel}
                        tooltip="Exportar em excel"
                        tooltipOptions={{position: 'top'}}
                        style={{maxHeight: '15px'}}
                    />                    
                )
            }
        }

        const renderExpansionTableButton = () => {
            if(this.props.tipo !== ConstantsUtil.liquidoFolha){
                return (
                    <ExpansionTableButton
                        expanded={this.state.expanded}
                        toggleExpansionTable={async () => {
                            await this.setState({expanded: !this.state.expanded})
                            await this.setState({selectedNome: ''})
                            this.props.dt.current.reset(); //reseta filtro
                        }}
                    />
                )
            }
        }

        return (
            <>

            <div className = "card-header header-small-height" >
            <div className='col-md-12'>
                
                <div className='row'>

                    {renderExpansionTableButton()}

                    <div className='col-md-4'>
                        <h5 className='small-font-size '>{this.getHeaderLabel()}</h5>
                    </div>
                    <div className='col-md-4'>
                        {/* <h5 className='small-font-size'>{this.getTableHeaders().periodo}</h5> */}
                    </div>
                    <div className='col-md-2'>
                    </div>
                    {renderExportarButton()}
                </div>
                
                
            </div>
            </div>

            
            {renderTable()}

            </>
        )
    }


}  

export default FolhaDePagamentoTable